import ApiService from '../apiservice'

export default class PublicacoesService extends ApiService {
  constructor() {
    super('/publicacoes')
  }

  consultarPublicacoes(filtro) {
    return this.get(`/filtro?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&pessoa=${filtro.pessoa}&numeroProcesso=${filtro.numeroProcesso}&advogado=${filtro.advogado}&lidas=${filtro.publicacoesLidas}&statusProcessuais=${filtro.statusProcessuais}&gruposTrabalho=${filtro.gruposTrabalho}&tribunais=${filtro.tribunais}&areasAtuacao=${filtro.areasAtuacao}&usuarioId=${filtro.usuario}&empresaId=${filtro.empresa}`);
  }

  consultarPublicacao(publicacaoId) {
    return this.get(`/consultar-publicacao/${publicacaoId}`);
  }

  gerarPdfPublicacao(publicacaoId) {
    return this.get2(`/publicacao/${publicacaoId}/pdf`);
  }

  consultarPublicacoesPordataAtual(empresaId) {
    return this.get(`/publicacoes-por-data-atual/${empresaId}`);
  }

	consultarPublicacaoLida(publicacaoId, usuarioId) {
		return this.get(`/consultar-publicacao-lida/${publicacaoId}/${usuarioId}`);
	}

	marcarPublicacaoComoLida(request) {
		return this.post('/marcar-publicacao-como-lida',request);
	}

	removerPublicacaoLida(publicacaoId, usuarioId) {
		return this.delete(`/publicacao-lida/remover/${publicacaoId}/${usuarioId}`);
	}

	buscarTribunais(empresa) {
		return this.get(`/tribunais/${empresa}`)
	}
}